import type { ReactNode } from 'react';

/** A failed action's message, shown next to the control that started it; the page around it stays. */
export default function InlineError({ children }: { children: ReactNode }) {
  return (
    <div
      role="alert"
      style={{
        fontSize: 12,
        color: 'var(--danger)',
        border: '1px solid var(--danger-line)',
        background: 'var(--danger-wash)',
        padding: '8px 12px',
        borderRadius: 8,
      }}
    >
      {children}
    </div>
  );
}
